<script>
import { hourglass } from "../store/boggle";
import { shotclock } from "../store/game";

export let user
export let toggleMenu
export let toggleProfile
export let showTimer
export let showCountdown
</script>

<div class="bg-teal-700 w-full">
  <div class="flex items-center justify-between py-2 px-4 max-w-md mx-auto text-white">
    <button on:click={toggleMenu} class="text-3xl text-white">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-menu-2" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </svg>
    </button>
    {#if showTimer}
      <div class="flex items-center justify-between text-white text-xl">
        <div class="border rounded-sm px-2 py-1 min-w-[100px]">{ $shotclock }</div>
      </div>
    {/if}
    {#if showCountdown}
      <div class="flex items-center justify-between text-white text-xl">
        <div class="border rounded-sm px-2 py-1 min-w-[100px]">{ $hourglass }</div>
      </div>
    {/if}
    
    <div class="h-10 w-10 rounded-full overflow-hidden border bg-white text-gray-600" on:click={toggleProfile}>
      {#if user.picture}
        <img src={user.picture} alt="Profile">
      {:else}
        <div class="w-full h-full flex items-center justify-center text-6xl">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <circle cx="12" cy="7" r="4" />
            <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
          </svg>
        </div>
        
      {/if}
    </div>
  </div>
</div>